function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #959595;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_5",
  "data-name": "Trazado 5",
  className: "cls-1",
  d: "M778.433,1776h-7.075a2.362,2.362,0,0,0-2.358,2.358v8.254a2.361,2.361,0,0,0,2.358,2.358h7.075a2.361,2.361,0,0,0,2.358-2.358v-8.254A2.362,2.362,0,0,0,778.433,1776Z",
  transform: "translate(-769 -1776)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_6",
  "data-name": "Trazado 6",
  className: "cls-1",
  d: "M790.433,1776h-7.075a2.362,2.362,0,0,0-2.358,2.358v8.254a2.361,2.361,0,0,0,2.358,2.358h7.075a2.361,2.361,0,0,0,2.358-2.358v-8.254A2.362,2.362,0,0,0,790.433,1776Z",
  transform: "translate(-766.85 -1776)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_7",
  "data-name": "Trazado 7",
  className: "cls-1",
  d: "M778.433,1789h-7.075a2.362,2.362,0,0,0-2.358,2.359v8.254a2.36,2.36,0,0,0,2.358,2.358h7.075a2.36,2.36,0,0,0,2.358-2.358v-8.254A2.362,2.362,0,0,0,778.433,1789Z",
  transform: "translate(-769 -1773.671)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_8",
  "data-name": "Trazado 8",
  className: "cls-1",
  d: "M790.433,1789h-7.075a2.362,2.362,0,0,0-2.358,2.359v8.254a2.36,2.36,0,0,0,2.358,2.358h7.075a2.36,2.36,0,0,0,2.358-2.358v-8.254A2.362,2.362,0,0,0,790.433,1789Z",
  transform: "translate(-766.85 -1773.671)"
});

function SvgTodaslascategorias(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Todas_las_categorias",
    "data-name": "Todas las categorias",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.942,
    height: 28.3,
    viewBox: "0 0 25.942 28.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodaslascategorias);
export default __webpack_public_path__ + "static/media/Todaslascategorias.d9219892.svg";
export { ForwardRef as ReactComponent };